import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';
import { disabledMapImage } from '../../constants/Images';

interface StyleProps {
  width?: string;
  height?: string;
  isEdit?: boolean;
}

export const MapContainer = styled.div`
  height: 370px;
  height: unset;
  background-color: ${COLORS.grey15};
  position: relative;
  flex-grow: 1;
  @media ${device.tablet} {
    max-height: 370px;
    height: 370px;
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    height: 100%;
    max-height: unset;
  }
`;

export const AddressContentWrapper = styled.div`
  position: absolute;
  width: ${({ width }: StyleProps) => width || '100%'};
  height: ${({ height }: StyleProps) => height || '100%'};
  top: 0;
`;

export const DisabledMap = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${disabledMapImage});
  background-size: cover;
`;
